// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.cs-red-btn[data-v-bf9cfa40] {\n  background-color: #ed1b2e;\n  border-radius: 8px;\n}\n", ""]);
// Exports
module.exports = exports;
